<section
  class="instant-estimate"
  [class.compact]="displayMode() === 'compact'"
  [style.background-color]="panelColor()"
  [style.--ie-accent]="accentColor()"
  [attr.aria-labelledby]="'instant-estimate-heading-' + schoolId()"
>
  <div class="sr-only" aria-live="polite" aria-atomic="true">{{ announcedText() }}</div>

  @if (!result().isValid) {
    <div class="alert alert-danger" role="alert">
      Instant estimate data is unavailable or invalid for this school.
      @if (result().validationErrors.length) {
        <ul>
          @for (err of result().validationErrors; track err) {
            <li>{{ err }}</li>
          }
        </ul>
      }
    </div>
  } @else {
    <header class="header-block">
      @if (showSchoolEyebrow()) {
        <p class="eyebrow">{{ config().schoolName }}</p>
      }
      <h2 [id]="'instant-estimate-heading-' + schoolId()" class="heading">
        Instant Net Price Estimate
      </h2>
    </header>

    <div class="summary">
      <p class="summary-context">
        At
        <strong>{{ result().income | currency: 'USD' : 'symbol' : '1.0-0' }}</strong>
        family income
      </p>
      <p class="summary-hero" [class.pulse]="heroPulse()">
        <span class="summary-hero-label">Estimated net price</span>
        <span class="summary-hero-value">
          {{ result().central | currency: 'USD' : 'symbol' : '1.0-0' }}
          <span class="summary-hero-unit">/year</span>
        </span>
      </p>
      <div class="summary-meta">
        <div class="meta-item">
          <span class="meta-label">Likely range</span>
          <span class="meta-value">
            {{ result().rangeLow | currency: 'USD' : 'symbol' : '1.0-0' }}–{{
              result().rangeHigh | currency: 'USD' : 'symbol' : '1.0-0'
            }}
          </span>
        </div>
        <div class="meta-item">
          <span class="meta-label">Published cost</span>
          <span class="meta-value">
            {{ publishedCostDisplay() | currency: 'USD' : 'symbol' : '1.0-0' }}
          </span>
        </div>
      </div>
    </div>

    <app-instant-estimate-chart
      [config]="config()"
      [result]="result()"
      [displayMode]="displayMode()"
      [accentColor]="accentColor()"
    />

    <div class="controls">
      <div class="controls-header">
        <label class="slider-label" [attr.for]="'income-slider-' + schoolId()">
          Family income
        </label>
        <div class="income-input-wrap">
          <span class="income-prefix" aria-hidden="true">$</span>
          <input
            class="income-input"
            type="text"
            inputmode="numeric"
            [id]="'income-input-' + schoolId()"
            [ngModel]="incomeInputText()"
            (ngModelChange)="onIncomeInputChange($event)"
            (blur)="onIncomeInputBlur()"
            aria-label="Family income amount"
          />
        </div>
      </div>

      <mat-slider
        [min]="minIncome"
        [max]="maxIncome"
        [step]="1000"
        discrete
        [displayWith]="currencyDisplay"
        class="income-slider"
      >
        <input
          matSliderThumb
          [id]="'income-slider-' + schoolId()"
          [ngModel]="income()"
          (ngModelChange)="onSliderChange($event)"
          [attr.aria-valuetext]="result().income | currency: 'USD' : 'symbol' : '1.0-0'"
          aria-label="Family income"
        />
      </mat-slider>

      <div class="slider-ends" aria-hidden="true">
        <span>{{ minIncome | currency: 'USD' : 'symbol' : '1.0-0' }}</span>
        <span>{{ maxIncome | currency: 'USD' : 'symbol' : '1.0-0' }}</span>
      </div>
    </div>

    <div class="actions">
      <button
        mat-raised-button
        type="button"
        class="cta-button"
        [style.background-color]="accentColor()"
        (click)="startFullCalculator()"
      >
        Get a personalized estimate
      </button>
    </div>

    <p class="disclaimer">
      This is an early ballpark estimate based primarily on family income. It is not a financial aid
      offer and does not replace the full Net Price Calculator.
    </p>
  }
</section>
